module.exports = __webpack_public_path__ + "img/InstagramAds.61e793a6.svg";